import { Dialog } from "tamagui";
import { jsx, jsxs } from "react/jsx-runtime";
const XPModal = props => {
  return /* @__PURE__ */jsxs(Dialog, {
    open: props.open,
    onOpenChange: props.onBackgroundPress,
    children: [/* @__PURE__ */jsx(Dialog.Trigger, {}), /* @__PURE__ */jsxs(Dialog.Portal, {
      children: [/* @__PURE__ */jsx(Dialog.Overlay, {
        backgroundColor: "rgba(255,255,255,.8)",
        ...(props.overlayProps || {})
      }), /* @__PURE__ */jsxs(Dialog.Content, {
        ...props.webContentProps,
        children: [props.children, /* @__PURE__ */jsx(Dialog.Close, {})]
      })]
    })]
  });
};
export { XPModal };
//# sourceMappingURL=XPModal.mjs.map
